import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelRadio as _vModelRadio, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/pdf-green.svg'
import _imports_1 from '@/assets/img/BotonPSE.png'


const _withScopeId = n => (_pushScopeId("data-v-41e96130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left flex-shrink-0" }
const _hoisted_2 = { class: "font-bold text-primary mb-4" }
const _hoisted_3 = {
  class: "overflow-y-auto",
  style: {"max-height":"calc(90vh - 80px)"}
}
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_6 = { class: "font-normal" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "inline-flex md:mr-2",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden md:inline-block" }, "Generar certificado", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "flex justify-between items-center" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "text-xs font-bold text-left text-gris80 md:text-sm" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-primary" }, "Saldo total", -1))
const _hoisted_17 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_18 = { class: "flex flex-col justify-between mt-3 p-2 rounded bg-lightSurface-50 md:flex-row" }
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = { class: "text-sm font-bold text-primary" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_23 = { class: "text-left" }
const _hoisted_24 = { class: "text-sm font-bold text-primary" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_27 = { class: "text-left" }
const _hoisted_28 = { class: "text-sm font-bold text-primary" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { class: "text-sm text-left font-bold text-gris80" }
const _hoisted_31 = { class: "flex flex-col justify-between mt-3 rounded" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary mb-1" }, "Datos del pago", -1))
const _hoisted_33 = { class: "bg-lightSurface-50 rounded p-2 flex flex-col gap-3 md:flex-row md:justify-between" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "minPay",
  class: "text-xs font-semibold text-gris80 md:text-sm"
}, "Pago mínimo: ", -1))
const _hoisted_37 = { class: "text-xs font-normal text-gris80" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "totalPay",
  class: "text-xs font-semibold text-gris80 md:text-sm"
}, "Pago total - Solo Pse: ", -1))
const _hoisted_41 = { class: "text-xs font-normal text-gris80" }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = {
  key: 0,
  class: "w-28"
}
const _hoisted_44 = ["value"]
const _hoisted_45 = {
  for: "customPay",
  class: "text-xs font-semibold text-gris80 md:text-sm"
}
const _hoisted_46 = { class: "flex flex-col justify-between mt-3 rounded md:flex-row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary" }, "Valor a pagar", -1))
const _hoisted_48 = { class: "text-lg font-bold lg:text-left text-gris120" }
const _hoisted_49 = { class: "flex flex-col mt-1 md:flex-row md:justify-end md:items-center" }
const _hoisted_50 = {
  key: 0,
  class: "mt-3 md:mt-0 ml-1 text-center"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs md:text-sm font-bold text-primary" }, [
  /*#__PURE__*/_createTextVNode("Transacción pendiente"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_52 = { class: "text-xs md:text-sm text-center font-bold text-gris80" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "pse",
  class: "btn-pse"
}, null, -1))
const _hoisted_55 = {
  key: 0,
  class: "hidden md:inline-block"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary mt-3" }, "Detalle de cuotas", -1))
const _hoisted_57 = { class: "scroll-table" }
const _hoisted_58 = {
  href: "",
  ref: "iPhoneLink",
  rel: "noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltips = _resolveComponent("Tooltips")!
  const _component_ModalPaymentChannels = _resolveComponent("ModalPaymentChannels")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_FeesTable = _resolveComponent("FeesTable")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCloseModal: _ctx.close,
          "custom-class": 'p-2 md:p-4 bg-lightSurface-50 max-h-[90vh] mx-2 overflow-hidden w-full sm:w-4/6 md:mx-0 md:w-5/6 lg:w-5/6 xl:w-4/6 2xl:w-3/6'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, [
                (_ctx.paymentDetail?.lince)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Resumen de cuotas por pagar ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Detalle de obligación ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["card", _ctx.showPaymentPlanTable ? 'mb-4' : 'mb-20'])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, [
                    _createTextVNode(" Fecha de obligación: "),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.formatDate(_ctx.paymentDetail?.created_at)), 1)
                  ]),
                  (
              !_ctx.loadingQuotaSummary &&
              !_ctx.isNegotiation &&
              !_ctx.isEndorsementAsociatedToAgreement
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "obligation-info-certificate-button",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateCertificate && _ctx.generateCertificate(...args)))
                        }, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["py-4", { 'md:border-b': !_ctx.showPaymentPlanTable }])
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        class: "obligations__card-img",
                        src: _ctx.paymentDetail?.urlLogo,
                        alt: _ctx.paymentDetail?.urlLogo
                      }, null, 8, _hoisted_13),
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.paymentDetail?.commerceName), 1),
                        _withDirectives(_createElementVNode("p", { class: "text-xs md:text-left text-gris80" }, _toDisplayString(_ctx.paymentDetail?.basedOn), 513), [
                          [_vShow, _ctx.paymentDetail?.basedOn]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$filters.currency(
                    _ctx.isActiveObligation
                      ? _ctx.paymentDetail?.valueMin
                      : _ctx.paymentDetail?.current_debt_value
                  )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, [
                        _createTextVNode(_toDisplayString(_ctx.isActiveObligation ? 'Saldo deuda' : 'Pago mínimo'), 1),
                        _hoisted_21
                      ]),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$filters.currency(_ctx.paymentDetail?.valueMin)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, [
                        _createTextVNode(_toDisplayString(_ctx.isActiveObligation
                    ? 'Fecha límite pago'
                    : 'Fecha límite pago mínimo'), 1),
                        _hoisted_25
                      ]),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.validatePaymentDate(
                    String(_ctx.paymentDetail?.limit_date_payment),
                    _ctx.paymentDetail?.register_type_state
                  )), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, [
                        _createTextVNode(_toDisplayString(_ctx.isActiveObligation
                    ? 'Cédula cliente'
                    : 'Número de ' + _ctx.writeText), 1),
                        _hoisted_29
                      ]),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.isActiveObligation
                    ? _ctx.paymentDetail?.identification
                    : _ctx.paymentDetail?.register_type_id), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      (!_ctx.isActiveObligation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _withDirectives(_createElementVNode("input", {
                              class: "checkbox-btn checkbox-position",
                              type: "radio",
                              id: "minPay",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedTotalToPay) = $event)),
                              value: _ctx.paymentType.minPay
                            }, null, 8, _hoisted_35), [
                              [_vModelRadio, _ctx.checkedTotalToPay]
                            ]),
                            _hoisted_36,
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$filters.currency(_ctx.paymentDetail?.valueMin)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showOtherOptions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("input", {
                              class: "checkbox-btn checkbox-position",
                              type: "radio",
                              id: "totalPay",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedTotalToPay) = $event)),
                              value: _ctx.paymentType.totalPay
                            }, null, 8, _hoisted_39), [
                              [_vModelRadio, _ctx.checkedTotalToPay]
                            ]),
                            _hoisted_40,
                            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$filters.currency(
                    _ctx.isActiveObligation
                      ? _ctx.paymentDetail?.valueMin
                      : _ctx.paymentDetail?.valueMax
                  )), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showOtherOptions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            (_ctx.hideFieldAnotherValue)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, " "))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "checkbox-btn checkbox-position",
                                    type: "radio",
                                    id: "customPay",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkedTotalToPay) = $event)),
                                    value: _ctx.paymentType.customPay
                                  }, null, 8, _hoisted_44), [
                                    [_vModelRadio, _ctx.checkedTotalToPay]
                                  ]),
                                  _createElementVNode("label", _hoisted_45, [
                                    _createTextVNode("Otro valor: "),
                                    _withDirectives(_createElementVNode("input", {
                                      class: "input-payment bg-white",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.totalToPay) = $event)),
                                      onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectCustomPay && _ctx.selectCustomPay(...args)))
                                    }, null, 544), [
                                      [_vModelText, _ctx.totalToPay]
                                    ])
                                  ])
                                ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", null, [
                      _hoisted_47,
                      _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$filters.currency(_ctx.eventChecktoPay)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_Tooltips, { title: "Aquí puede ver otras opciones para pagos en efectivo" }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.physicalPayment && _ctx.physicalPayment(...args))),
                            class: "w-full px-4 py-2 mt-3 md:mt-0 text-xs text-white rounded-lg mr-3 bg-secondary border md:w-auto md:text-sm h-10"
                          }, " Pago en efectivo ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ModalPaymentChannels, {
                        "is-visible": _ctx.showModalPaymentChannels,
                        paymentChannels: _ctx.getReferenceAndAgreement,
                        onClose: _ctx.closeModalPaymentChannels
                      }, null, 8, ["is-visible", "paymentChannels", "onClose"]),
                      (!_ctx.canMakePayment(_ctx.paymentDetail?.reference))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _hoisted_51,
                            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.paymentDetail?.reference), 1)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!_ctx.isLoadingPaymentStatus)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "submit",
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.makePayment && _ctx.makePayment(...args)), ["prevent"])),
                                  class: _normalizeClass(["w-full px-4 py-2 text-sm mt-3 text-white rounded-lg bg-success md:w-64 md:mt-0 md:text-sm order-first md:order-none btn-pse-container h-10", { 'cursor-not-allowed': !_ctx.valueGreaterThanZero }]),
                                  disabled: !_ctx.valueGreaterThanZero
                                }, [
                                  _hoisted_54,
                                  _createTextVNode(" Realizar pago online ")
                                ], 10, _hoisted_53))
                              : _createCommentVNode("", true)
                          ], 64))
                    ])
                  ])
                ], 2),
                (!_ctx.showPaymentPlanTable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_Loader, {
                          showLoader: _ctx.loadingQuotaSummary,
                          styles: 'relative'
                        }, null, 8, ["showLoader"]),
                        _createVNode(_component_FeesTable, {
                          "fees-summary": _ctx.payPlan?.data?.attributes,
                          "is-lince": _ctx.paymentDetail?.lince
                        }, null, 8, ["fees-summary", "is-lince"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    _createElementVNode("a", _hoisted_58, null, 512)
  ], 64))
}